// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"1d38166c","342":"91805435","821":"7e67203d","928":"c2fa58bb"}[chunkId] + ".chunk.js";
};